import React from "react";
import { Link } from "react-router-dom";
import "./SiteFooter.css";

const SiteFooter = () => (
  <footer className="sf">
    <div className="sf-wrap sf__grid">
      {/* Brand */}
      <div className="sf__brand">
        <Link to="/">
          <img src="/Magis.svg" alt="Magisters Hub" className="sf__logo" />
        </Link>
        <p>Magisters Hub is the world's leading online bootcamp. We help professionals and students learn and master the most in-demand skills.</p>
        <div className="sf__social">
          <a href="#" aria-label="Facebook">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
          </a>
          <a href="#" aria-label="Twitter/X">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>
          </a>
          <a href="#" aria-label="LinkedIn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
          </a>
        </div>
      </div>

      {/* Courses */}
      <div>
        <h4>Courses</h4>
        <ul>
          <li><Link to="/courses?category=Full Stack Development">Full Stack Development</Link></li>
          <li><Link to="/courses?category=AI & Machine Learning">AI & Machine Learning</Link></li>
          <li><Link to="/courses?category=Data Science">Data Science</Link></li>
          <li><Link to="/courses?category=Cyber Security">Cyber Security</Link></li>
          <li><Link to="/courses?category=Cloud Computing">Cloud Computing</Link></li>
          <li><Link to="/courses?category=Product Management">Product Management</Link></li>
        </ul>
      </div>

      {/* Company */}
      <div>
        <h4>Company</h4>
        <ul>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/about/mentors">Our Mentors</Link></li>
          <li><Link to="/about/university-partners">University Partners</Link></li>
          <li><Link to="/about/careers">Careers</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/enterprise/corporate-training">For Business</Link></li>
        </ul>
      </div>

      {/* Resources */}
      <div>
        <h4>Resources</h4>
        <ul>
          <li><Link to="/resources/blog">Blog</Link></li>
          <li><Link to="/resources/success-stories">Success Stories</Link></li>
          <li><Link to="/resources/webinars">Webinars</Link></li>
          <li><Link to="/resources/career-guides">Career Guides</Link></li>
          <li><Link to="/resources/interview-preparation">Interview Prep</Link></li>
        </ul>
      </div>

      {/* Newsletter */}
      <div className="sf__newsletter">
        <h4>Stay Updated</h4>
        <p>Get the latest career trends and course updates.</p>
        <form className="sf__form" onSubmit={e => e.preventDefault()}>
          <input type="email" placeholder="Your email address" />
          <button type="submit">Subscribe</button>
        </form>
        <div className="sf__badges">
          <a href="#" className="sf__badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg>
            ISO Certified
          </a>
          <a href="#" className="sf__badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
            Top Rated
          </a>
        </div>
      </div>
    </div>

    <div className="sf-wrap sf__bottom">
      <p>© {new Date().getFullYear()} Magisters Hub Inc. All rights reserved.</p>
      <div className="sf__links">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Service</a>
        <a href="#">Cookie Policy</a>
        <a href="#">Sitemap</a>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
